const ID = 'breadcrumb';

export default ID;
